import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { I18nProvider } from './i18n/I18nProvider';
import { LanguageProvider } from './i18n/LanguageProvider';
import { BrandGate } from './theme/BrandGate';
import { ThemeProvider } from './theme/ThemeProvider';
import './index.css';

// Provider order matters: language → theme (direction swaps the font roles)
// → brand fetch (needs auth + i18n for the document title) → router → app.
// Everything under App, including the public /a/:token pages, inherits
// branding, language and direction from here.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth0Provider>
      <LanguageProvider>
        <ThemeProvider>
          <I18nProvider>
            <BrandGate>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </BrandGate>
          </I18nProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
